import React, { useState, useEffect } from 'react';
import SetCourseTerm from "../SetCourseTerm/SetCourseTerm"

import './CourseTerm.css';

export default function CourseTerm({ setAmount, setTerms, terms }) {
    const date = new Date();
    const [loading, setLoading] = useState(false);

    const getRandomId = () => {
      return Math.random().toString(36).substring(2,7);
    }

    const addTerm = () => {
      const termTemp = { id: getRandomId(), name: '' };
      setTerms([ ...terms, termTemp ]);
    }

    const deleteTerm = (id) => {
      if (terms.length > 1) {
        setLoading(true);
        setTerms(terms.filter(term => term.id !== id));
        setLoading(false);
      }
    }

    useEffect(async () => {
    }, [terms])

    return (
        <>
          {terms.length > 0 && !loading && terms.map((term) => (
            <SetCourseTerm 
              term={term}
              terms={terms} 
              setTerms={setTerms} 
              addTerm={addTerm}
              deleteTerm={deleteTerm}
              setAmount={setAmount}
            />
          ))}

        </>
    );
}